if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.form = document.getElementById(this.dataset.productFormId);
      this.variantDialog = this.querySelector('.sticky-atc-panel__dialog');
      this.openButton = this.querySelector('.js-sticky-atc-open');
      this.activeSubmitButton = null;

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      this.observer?.disconnect();
    }

    bindEvents() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) this.observer.observe(this.productForm);
      if (this.productInfo) this.observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
      this.addEventListener('click', this.handleClick.bind(this));
      this.variantDialog?.addEventListener('click', this.handleDialogClick.bind(this));
      this.variantDialog?.addEventListener('close', this.handleDialogClose.bind(this));
      this.productSection.addEventListener('on:cart:add', this.handleCartResponse.bind(this));
      this.productSection.addEventListener('on:line-item:change', this.handleCartResponse.bind(this));
      this.productSection.addEventListener('on:cart:error', this.handleCartResponse.bind(this));
    }

    handleClick(evt) {
      const openButton = evt.target.closest('.js-sticky-atc-open');
      if (openButton) {
        if (openButton.getAttribute('aria-disabled') === 'true') return;
        this.openVariantDialog();
        return;
      }

      const submitButton = evt.target.closest('.js-sticky-atc-submit');
      if (submitButton) this.addVariantToCart(submitButton);
    }

    handleDialogClick(evt) {
      if (evt.target.closest('.js-sticky-atc-close')) {
        this.variantDialog.close();
        return;
      }

      if (evt.target !== this.variantDialog) return;

      const dialogRect = this.variantDialog.getBoundingClientRect();
      const clickedInside = (
        evt.clientX >= dialogRect.left
        && evt.clientX <= dialogRect.right
        && evt.clientY >= dialogRect.top
        && evt.clientY <= dialogRect.bottom
      );

      if (!clickedInside) this.variantDialog.close();
    }

    openVariantDialog() {
      if (!this.variantDialog || this.variantDialog.open) return;

      this.scrollY = window.scrollY;
      document.body.classList.add('fixed');
      document.body.style.top = `-${this.scrollY}px`;
      this.variantDialog.showModal();
      this.openButton?.setAttribute('aria-expanded', 'true');
      this.variantDialog.querySelector('.js-sticky-atc-close')?.focus();
    }

    handleDialogClose() {
      document.body.style.top = '';
      document.body.classList.remove('fixed');
      window.scrollTo(0, this.scrollY);
      this.openButton?.setAttribute('aria-expanded', 'false');
      this.openButton?.focus();
    }

    addVariantToCart(button) {
      if (!this.form || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      const variantInput = this.form.querySelector('[name="id"]');
      const mainSubmitButton = this.form.querySelector('[name="add"]');
      if (!variantInput || mainSubmitButton?.getAttribute('aria-disabled') === 'true') return;

      const previousVariantId = variantInput.value;
      const variantInputWasDisabled = variantInput.disabled;
      variantInput.disabled = false;
      variantInput.value = button.dataset.variantId;
      if (this.variantDialog?.open) this.variantDialog.close();

      if (!this.form.reportValidity()) {
        variantInput.value = previousVariantId;
        variantInput.disabled = variantInputWasDisabled;
        return;
      }

      this.activeSubmitButton = this.variantDialog?.contains(button) ? this.openButton : button;
      this.activeSubmitButton.setAttribute('aria-disabled', 'true');
      this.activeSubmitButton.setAttribute('aria-busy', 'true');
      this.activeSubmitButton.classList.add('is-loading');

      this.form.requestSubmit();
      variantInput.value = previousVariantId;
      variantInput.disabled = variantInputWasDisabled;
    }

    handleCartResponse() {
      if (!this.activeSubmitButton) return;

      this.activeSubmitButton.removeAttribute('aria-disabled');
      this.activeSubmitButton.removeAttribute('aria-busy');
      this.activeSubmitButton.classList.remove('is-loading');
      this.activeSubmitButton.classList.add('is-success');

      setTimeout(() => {
        this.activeSubmitButton?.classList.remove('is-success');
        this.activeSubmitButton = null;
      }, 1400);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
